/* B&A Label Finder — the two levels are editable Shopify section blocks. */
(function () {
  function mount(section) {
    if (section.dataset.baLabelFinderReady === 'true') return;
    section.dataset.baLabelFinderReady = 'true';
    var typeView = section.querySelector('[data-ba-types]');
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-ba-type-panel]'));
    if (!typeView || !panels.length) return;
    var typeButtons = Array.prototype.slice.call(section.querySelectorAll('[data-ba-choose-type]'));

    function showType(id, focusHeading) {
      var current = panels.find(function (panel) { return panel.getAttribute('data-ba-type-panel') === id; });
      typeView.hidden = !!current;
      panels.forEach(function (panel) { panel.hidden = (panel !== current); });
      if (current && focusHeading) {
        var heading = current.querySelector('[data-ba-panel-heading]');
        if (heading) heading.focus({ preventScroll: true });
        section.scrollIntoView({ behavior: 'auto', block: 'start' });
      } else if (!current && focusHeading) {
        var title = section.querySelector('.ba-lf__title');
        if (title) { title.setAttribute('tabindex', '-1'); title.focus({ preventScroll: true }); }
        section.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    }

    showType('', false);
    typeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        var id = button.getAttribute('data-ba-choose-type');
        if (!panels.some(function (panel) { return panel.getAttribute('data-ba-type-panel') === id; })) return;
        event.preventDefault();
        showType(id, true);
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', button.getAttribute('href'));
      });
    });
    section.querySelectorAll('[data-ba-back]').forEach(function (back) {
      back.addEventListener('click', function (event) {
        event.preventDefault();
        showType('', true);
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', window.location.pathname + window.location.search);
      });
    });
    function syncHash() {
      var prefix = '#ba-label-type-' + section.dataset.baLabelFinder + '-';
      if (window.location.hash.indexOf(prefix) === 0) showType(decodeURIComponent(window.location.hash.slice(prefix.length)), false);
      else showType('', false);
    }
    syncHash();
    window.addEventListener('hashchange', syncHash);
  }
  function init(root) {
    (root || document).querySelectorAll('[data-ba-label-finder]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
